
import React, { useState } from 'react';

function TimestampConverter() {
  const [timestamp, setTimestamp] = useState('');
  const [date, setDate] = useState('');

  const convertToTimestamp = () => setTimestamp(Math.floor(new Date(date).getTime() / 1000));
  const convertToDate = () => setDate(new Date(timestamp * 1000).toLocaleString());

  return (
    <div className="encoder-decoder"  id="TimestampConverter">
      <h2>Timestamp Converter</h2>
       <div className="description-section">
           <p>
Convert timestamps into human-readable dates with our Timestamp Converter. This tool converts Unix timestamps to dates and vice versa, offering quick conversion for time-sensitive data processing. Developers frequently working with date and time formats will find this tool especially helpful for data logging, event tracking, and much more.
        </p>
          </div>
      <input className="input-textarea" type="text" placeholder="Enter Unix Timestamp" onChange={(e) => setTimestamp(e.target.value)} />
      <button className="beautify-button"  onClick={convertToDate}>Convert to Date</button>
      <p>Date: {date}</p>
      <input className="input-textarea" type="text" placeholder="Enter Date (YYYY-MM-DD)" onChange={(e) => setDate(e.target.value)} />
      <button className="beautify-button"  onClick={convertToTimestamp}>Convert to Timestamp</button>
      <p>Timestamp: {timestamp}</p>
    </div>
  );
}

export default TimestampConverter;
